export default "__VITE_ASSET__B6aPnFP6__"